import { Flex, Typography } from "antd";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { AiTwotoneCompass, AiOutlineCompass } from "react-icons/ai";
import { MdOutlineVpnKey } from "react-icons/md";
import { NavLink } from "react-router";

import { useThemeMode } from "sandbox/contexts/ThemeModeContext";
import { useSandboxLogo } from "sandbox/hooks";
import { sandboxPaths } from "sandbox/paths";
import { AMP_UNMASK_PROPS } from "shell/api/amplitudePrivacy";

import s from "./SandboxSidebar.module.css";

interface SandboxSidebarProps {
  collapsed?: boolean;
}

export const SandboxSidebar = ({ collapsed = false }: SandboxSidebarProps) => {
  const { t } = useTranslation("sandbox");
  const { mode } = useThemeMode();
  const logo = useSandboxLogo();

  const ITEMS = [
    {
      label: t("components.sandboxSidebar.labels.sandbox"),
      to: sandboxPaths.explorer,
      Icon: mode === "dark" ? AiOutlineCompass : AiTwotoneCompass,
    },
    // {
    //   to: sandboxPaths.recipes,
    //   Icon: AiOutlineApartment,
    // },
    {
      label: t("labels.credentials"),
      to: sandboxPaths.credentials,
      Icon: MdOutlineVpnKey,
    },
  ];

  return (
    <aside
      className={clsx(
        s.sidebar,
        collapsed && s.sidebarCollapsed,
        mode === "dark" && s.sidebarDark,
      )}
    >
      <nav className={s.nav} {...AMP_UNMASK_PROPS}>
        {ITEMS.map(({ to, Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            end={to !== sandboxPaths.recipes}
            className={({ isActive }) =>
              clsx(
                mode === "dark" ? s.itemDark : s.item,
                isActive && (mode === "dark" ? s.itemActiveDark : s.itemActive),
              )
            }
            title={collapsed ? label : undefined}
          >
            <Icon className={s.icon} aria-hidden />
            {!collapsed && <span className={s.itemLabel}>{label}</span>}
          </NavLink>
        ))}
      </nav>
      {!collapsed && (
        <Flex
          vertical
          align="center"
          className={s.sidebarLogoContainer}
          data-testid="sidebar-logo-container"
        >
          <Typography.Text
            type="secondary"
            className={s.sidebarLogoTextDark}
            data-testid="sidebar-logo-text"
          >
            {t("labels.poweredBy")}
          </Typography.Text>
          <img src={logo} width={80} height={32} alt="Thredd" />
        </Flex>
      )}
    </aside>
  );
};
